import cookie from "cookie";

/**
 * Retrieve the cookies from a request object
 * @param {Object} req - A request object.
 * @returns {String} The cookies from the request headers.
 */
export const getReqCookies = (req) => req && req.headers && req.headers.cookie;

/**
 * Sets cookie headers from the API response on the res and req objects for the Node.js server
 * @param {Object} req - A request object.
 * @param {Object} res - A response object.
 * @returns {(resp: Object) => Object}
 */
export const setCookies = ({ req, res }) => (resp) => {
  const cookieHeader = resp.headers && resp.headers.get("set-cookie");

  if (res && cookieHeader) {
    // Pass set cookie requests from the API through Node.js server to the browser
    res.setHeader("Set-Cookie", cookieHeader);
  }

  if (req && cookieHeader) {
    // Set cookies received from the API onto Node.js request object so that
    // chained request have access to the latest cookies
    req.headers.cookie = cookieHeader;
  }

  return resp;
};

/**
 * Utility function to get a specific cookie from raw headers.
 * @param {Array} rawHeaders - The raw headers array from the request.
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {string|null} The value of the specified cookie, or null if not found.
 */
export function getCookieFromRawHeaders(rawHeaders = [], cookieName) {
  if (!Array.isArray(rawHeaders)) return null;

  // Search for the 'Cookie' header in raw headers
  for (let i = 0; i < rawHeaders.length; i += 2) {
    if (rawHeaders[i].toLowerCase() === "cookie" && rawHeaders[i + 1]) {
      const cookies = cookie.parse(rawHeaders[i + 1]); // Parse the cookies string
      return cookies[cookieName] || null; // Return the specified cookie value or null if not found
    }
  }

  return null; // Return null if 'Cookie' header is not found
}
